module.exports = __webpack_public_path__ + "img/88ne.0917daf3.svg";